import * as React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import TextCard from './TextCard';
import TextCardPipe from './TextCardPipe';
import TextCardStars from './TextCardStars';
import TextCardBold from './TextCardBold';
import Divider from '@mui/material/Divider';
import { useTheme } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import VariantLine from './VariantLine';



export default function VariantCardAccordion({marker, gene, gene_name, MANE_SELECT, location, group, variation, var_g, consequence, var_p, gt, type, exon, rs, clinvarID, expert, classification, pheno, pheno_name}) {

  const theme = useTheme();
   
    return (

      theme.palette.mode === "light" ? (

    <Box sx={{mb:2.5}}>
      <Accordion elevation={3} sx={{mb:2, bgcolor: 'grey.C200', }}>
        
        <AccordionSummary expandIcon={<ExpandMoreIcon />} >
          <VariantLine marker={ marker } textcard= {classification} textcard_2 = {<TextCardStars textcheck={expert} />} /> 
        </AccordionSummary> 
     
        <AccordionDetails>
      
        <Grid container sx={{mb:2, p:3, display: 'flex', justifyContent: 'flex-start', alignItems: 'center',  borderRadius: '10px', border: 'groove', }}> 
                   
                   <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', pb:1}}> Gene: &nbsp;&nbsp;<TextCardBold textcard= {gene} /> </Grid> 
                   <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}> Functionality: &nbsp;&nbsp;  <TextCard textcard={gene_name} /> </Grid> 
                   <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}> MANE Identifier: &nbsp;&nbsp; <TextCard textcard={MANE_SELECT} /></Grid> 
                   <Grid size={12} sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  Gene type: &nbsp;&nbsp; <TextCard textcard={group} /></Grid>       
   
             <Grid size={12}>  <Divider role="presentation" sx={{mt:2, mb:2, borderBottomWidth: '1px', borderBottomColor: 'common.black' }}/> </Grid>
   
             <Grid size={12} sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', pb:1}}> Variant: &nbsp;&nbsp; <TextCardBold textcard={location} /> </Grid>  
                 <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}> Seq-Identifier: &nbsp;&nbsp;  <TextCard textcard={var_g}/></Grid>              
                 <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}> Prot-Identifier: &nbsp;&nbsp; <TextCard textcard={var_p}/> </Grid> 
                 
                 <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}> dbSNP-Identifier: &nbsp;&nbsp; <TextCard textcard={rs} /></Grid>
                 <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}> Var-Type: &nbsp;&nbsp; <TextCard textcard={type} textcard2={consequence}/> </Grid>
                 <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>   EXON: &nbsp;&nbsp; <TextCard textcard={exon} /></Grid> 
                 <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  clinvar: &nbsp;&nbsp; <TextCard textcard={clinvarID} /></Grid>
                 <Grid size={12} sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}> Evidence: &nbsp;&nbsp; <TextCard textcard={expert}/> </Grid> 
   
             <Grid size={12}>  <Divider role="presentation" sx={{mt:2, mb:2, borderBottomWidth: '1px', borderBottomColor: 'common.black' }}/> </Grid>
   
             <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', pb:1}}> <TextCardBold textcard={pheno} /> </Grid>
                 <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', flexWrap: 'wrap'}}>   <TextCardPipe textcard={pheno_name} /> </Grid> 
         
         </Grid>   
    </AccordionDetails>

  </Accordion>
</Box>

) : (

  <Box sx={{mb:2}}>
  <Accordion elevation={3} sx={{mb:2, bgcolor: 'greydark.C500', }}>
    
    <AccordionSummary expandIcon={<ExpandMoreIcon />} >
      <VariantLine marker={marker} textcard= {classification} textcard_2 = {<TextCardStars textcheck={expert} />}   /> 
    </AccordionSummary> 
 
    <AccordionDetails sx={{ }}>
    <Grid container sx={{mb:2, p:3, display: 'flex', justifyContent: 'flex-start', alignItems: 'center',  borderRadius: '10px', border: 'groove', }}> 
                   
                   <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', pb:1}}> Gene: &nbsp;&nbsp;<TextCardBold textcard= {gene} /> </Grid> 
                   <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}> Functionality: &nbsp;&nbsp;  <TextCard textcard={gene_name} /> </Grid> 
                   <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}> MANE Identifier: &nbsp;&nbsp; <TextCard textcard={MANE_SELECT} /></Grid> 
                   <Grid size={12} sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  Gene type: &nbsp;&nbsp; <TextCard textcard={group} /></Grid>       
   
             <Grid size={12}>  <Divider role="presentation" sx={{mt:2, mb:2, borderBottomWidth: '1px', borderBottomColor: 'common.black' }}/> </Grid>
   
             <Grid size={12} sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', pb:1}}> Variant: &nbsp;&nbsp; <TextCardBold textcard={location} /> </Grid>  
                 <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}> Seq-Identifier: &nbsp;&nbsp;  <TextCard textcard={var_g}/></Grid>              
                 <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}> Prot-Identifier: &nbsp;&nbsp; <TextCard textcard={var_p}/> </Grid> 
                 
                 <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}> dbSNP-Identifier: &nbsp;&nbsp; <TextCard textcard={rs} /></Grid>
                 <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}> Var-Type: &nbsp;&nbsp; <TextCard textcard={type} textcard2={consequence}/> </Grid>
                 <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>   EXON: &nbsp;&nbsp; <TextCard textcard={exon} /></Grid> 
                 <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  clinvar: &nbsp;&nbsp; <TextCard textcard={clinvarID} /></Grid>
                 <Grid size={12} sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}> Evidence: &nbsp;&nbsp; <TextCard textcard={expert}/> </Grid> 
   
             <Grid size={12}>  <Divider role="presentation" sx={{mt:2, mb:2, borderBottomWidth: '1px', borderBottomColor: 'common.black' }}/> </Grid>
   
             <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', pb:1}}> <TextCardBold textcard={pheno} /> </Grid>
                 <Grid size={12}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', flexWrap: 'wrap'}}>   <TextCardPipe textcard={pheno_name} /> </Grid> 
         
         </Grid>   
</AccordionDetails>

</Accordion>
</Box>
      )

    );
  }